import './Category.css';

const Category = () => (
  <div className="main-category">
    <h2>Page Under Construction</h2>
  </div>
);

export default Category;
